import React from 'react'
import { SvgIcon } from '@material-ui/core'

function CardSizeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector'
        d='M16.3028 7.6977C16.4294 7.82429 16.5005 7.99598 16.5005 8.175V10.425C16.5005 10.7978 16.1983 11.1 15.8255 11.1C15.4527 11.1 15.1505 10.7978 15.1505 10.425V9.80413L13.6022 11.3518C13.3385 11.6154 12.9111 11.6153 12.6475 11.3516C12.384 11.088 12.3841 10.6606 12.6478 10.3971L14.1954 8.85H13.5744C13.2017 8.85 12.8994 8.54779 12.8994 8.175C12.8994 7.80221 13.2017 7.5 13.5744 7.5H15.8255C16.0045 7.5 16.1762 7.57112 16.3028 7.6977Z'
      />
      <path
        id='Vector_2'
        d='M7.5 15.8237C7.5 16.0027 7.57112 16.1744 7.6977 16.301C7.82429 16.4276 7.99598 16.4987 8.175 16.4987H10.4261C10.7989 16.4987 11.1011 16.1965 11.1011 15.8237C11.1011 15.4509 10.7989 15.1487 10.4261 15.1487H9.8044L11.3524 13.6005C11.6159 13.3369 11.6159 12.9095 11.3523 12.6459C11.0887 12.3823 10.6612 12.3824 10.3976 12.646L8.85 14.1939V13.5737C8.85 13.2009 8.54779 12.8987 8.175 12.8987C7.80221 12.8987 7.5 13.2009 7.5 13.5737V15.8237Z'
      />
      <path
        id='Vector_3'
        d='M3 7.2748C3 5.9079 4.1081 4.7998 5.475 4.7998H18.525C19.8919 4.7998 21 5.9079 21 7.2748V16.7248C21 18.0917 19.8919 19.1998 18.525 19.1998H5.475C4.1081 19.1998 3 18.0917 3 16.7248V7.2748ZM5.475 6.1498C4.85368 6.1498 4.35 6.65348 4.35 7.2748V16.7248C4.35 17.3462 4.85368 17.8498 5.475 17.8498H18.525C19.1464 17.8498 19.65 17.3462 19.65 16.7248V7.2748C19.65 6.65348 19.1464 6.1498 18.525 6.1498H5.475Z'
      />
    </SvgIcon>
  )
}

export default CardSizeIcon
